
import PasswordGenerator from '../img/pg-img.jpg'
import MyNightHome from '../img/mynighthome-img.jpg'
import MyDoctor from '../img/mydoctor-img.jpg'
import BudgetTracker from '../img/budgettracker-img.jpg'
import EMS from '../img/ems.jpg'
import ProgressTracker from '../img/TVshowtracker.jpg'
export const portfolio = [
    {
        id: 1,
        img: PasswordGenerator,
        name: PasswordGenerator,
        link: "https://github.com/Elijahb22/Password-Generator"
    },
    {
        id: 2,
        img: MyNightHome,
        name: MyNightHome,
        link: "https://github.com/graysontmiller/mynightthome-project-1"
    },
    {
        id: 3,
        img: MyDoctor,
        name: MyDoctor,
        link: "https://github.com/KaitlynMilliken/Project-2"
    },
    {
        id: 4,
        img: EMS,
        name: EMS,
        link: "https://github.com/metafework/EMSProject"
    },
    {
        id: 5,
        img: BudgetTracker,
        name: BudgetTracker,
        link:"https://github.com/Elijahb22/budget-tracker"
    },
    {
        id: 6,
        img: ProgressTracker,
        name: ProgressTracker,
        link: "https://github.com/Talha215/ProgressTracker"  
    }
];